export default {"src":"/_next/static/media/blog.369bc3f0.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};